import React from "react";
import { Box } from "@mui/material";

const shimmer = {
    background: "linear-gradient(90deg,#EDEDED 0%,#F6F6F6 40%,#EDEDED 80%)",
    backgroundSize: "420px 100%",
    animation: "tvpShimmer 1.2s linear infinite",
};

const PostTileSkeleton = ({ ratio = "3 / 4", width }) => (
    <Box
        sx={width
            ? { flex: "0 0 auto", width }
            : { margin: "0 0 10px", breakInside: "avoid", WebkitColumnBreakInside: "avoid" }}
    >
        <Box
            sx={{
                ...shimmer,
                aspectRatio: ratio,
                borderRadius: (theme) => theme.tvp.radiusMedia,
            }}
        />
    </Box>
);

export default PostTileSkeleton;
